// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__AgzVX","compact":"style_compact__JPd4F","small":"style_small__MOV8Q","square":"style_square__xmu58"};